module.exports = __webpack_public_path__ + "img/letter_of_wishes.4dc39e35.svg";